import { t } from "i18next";

export const Roles = {
  admin: 1,
  user: 2,
  dispatcher: 3,
  technical: 4,
  accountant: 5,
  distributor: 6,
  client: 7,
  sales: 8,
  operation: 9,
  coordinator: 10,
  technical_supervisor: 11,
  outsource_technical: 12
};

export const Ticket = {
  create: "0",
  pending: "1",
  priced: "9",
  active: "2",
  done: "3",
  approved: "4",
  denied: "5",
  paid: "10",
  partialPaid: "11",
  assigned: "12",
  ticket_paused: "13",
  new_client_request: "15",
  opened_client_request: "16",
  closed_client_request: "17",
  verfied_client_request: "18",
  paid_client_request: "19"
};
export const RequestClientStatus = {
  create: "0",
  request_new: "15",
  request_open: "16",
  request_closed: "17",
  request_verfied: "18",
  request_paid: "19",
  archived: "20",
};

export const TicketKeyName = {
  create: () => t("create"),
  pending: () => t("pending"),
  priced: () => t("priced"),
  active: () => t("active_only"),
  done: () => t("done"),
  approved: () => t("approved"),
  denied: () => t("denied"),
  paid: () => t("paid"),
  paidClient: "مدفوعة",
  partialPaid: () => t("partially_paid"),
  assigned: () => t("assigned"),
  ticket_paused: () => t("ticket_paused"),
};

export const ClientRequestKeyName = {
  create: () => t("create"),
  pending: () => t("pending"),
  priced: () => t("priced"),
  active: () => t("active"),
  done: () => t("done"),
  approved: () => t("approved"),
  denied: () => t("denied"),
  paid: () => t("paid"),
  paidClient: "مدفوع",
  partialPaid: () => t("partially_paid"),

  request_new: () => t("new"),
  request_open: () => t("open"),
  request_closed: () => t("closed"),
  request_verfied: () => t("verified"),
  request_paid: () => t("request_paid"),
  archived: () => t("archived"),
};
